export default "__VITE_ASSET__gqrvDGd7__"